import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import {Stack} from "@mui/material";
import Box from "@mui/material/Box";
import logo from "../../assets/logo.png";
import Button from "@mui/material/Button";
import {NavLink, Link} from "react-router-dom";
import {IconLogin, IconPlus} from "@tabler/icons-react";
import {auth} from "../../utils/firebaseApp";

export const MainLayout = ({children}) => {

  return (
    <>
      <AppBar color={"transparent"} elevation={0} position={"fixed"} sx={{zIndex: 1000}}>
        <Toolbar color={"transparent"} sx={{px: 2, gap: 1}}>
          <img src={logo} height={30} width={"auto"} alt={"Logo"}/>

          {
            auth?.currentUser ? <>
                <Button component={NavLink} to={"/projects"} sx={{ml: "auto", fontSize: 12, borderBottom: 2}}
                        className={"nav-link"}>
                  Projects Dashboard
                </Button>
                <Button component={NavLink} to={"/account"} sx={{fontSize: 12, borderBottom: 2}} className={"nav-link"}>
                  My account
                </Button>

                <Button
                  className={"gradient-bg"}
                  sx={{borderRadius: 5, color: "#FFF", px: 2, fontSize: 12}}
                  startIcon={<IconPlus size={15}/>}
                >
                  New Project
                </Button>
              </> :
              <>
                <Button component={NavLink} to={"/professional"} sx={{ml: "auto", fontSize: 12, borderBottom: 2}} className={"nav-link"}>
                  Professional
                </Button>
                <Button component={NavLink} to={"/engagement"} sx={{fontSize: 12, borderBottom: 2}} className={"nav-link"}>
                  Engagement
                </Button>

                <Button
                  component={Link}
                  to={"/login"}
                  className={"gradient-bg"}
                  sx={{borderRadius: 5, color: "#FFF", px: 2, fontSize: 12}}
                  startIcon={<IconLogin size={15} />}
                >
                  Login
                </Button>
              </>
          }

        </Toolbar>
      </AppBar>
      <Stack direction={"column"} sx={{height: "100dvh", maxHeight: "100dvh", width: "100vw"}}>
        <Toolbar sx={{opacity: 0}}/>
        <Box sx={{flex: 1, overflowY: "auto"}}>
          {children}
        </Box>
      </Stack>
    </>
  )
}